import React, { Component } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CBadge,
  CCardFooter,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CTextarea
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

class CommunityContentForum extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      forum: null,
      // search: "",
      // tab: 1,
      deleteModal: false,
      deleteId: null,
      comment: "",
      answer: "",
      answerId: null
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.updateForum();
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  comment() {
    const { id } = this.props.match.params;
    const forumId = window.location.pathname.substr(
      window.location.pathname.lastIndexOf("/") + 1
    );

    axios
      .post(
        `${URL.api}communication/forum/insert`,
        {
          description: this.state.comment,
          room_id: id,
          user_id: this.props.user.user.id,
          forum_id: forumId
        },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({ comment: "" });

          this.updateForum();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  answer() {
    const { id } = this.props.match.params;

    axios
      .post(
        `${URL.api}communication/forum/insert`,
        {
          description: this.state.answer,
          room_id: id,
          user_id: this.props.user.user.id,
          forum_id: this.state.answerId
        },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({ answer: "" });

          this.updateForum();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  like(forum, like) {
    if (forum.user_like !== like) {
      axios
        .post(
          `${URL.api}communication/forum/like`,
          { like, user_id: this.props.user.user.id, forum_id: forum.id },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        )
        .then(
          resp => {
            this.updateForum();
          },
          error => {
            this.error(error.response.statusText);
          }
        );
    } else {
      axios
        .post(
          `${URL.api}communication/forum/like`,
          { like: null, user_id: this.props.user.user.id, forum_id: forum.id },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        )
        .then(
          resp => {
            this.updateForum();
          },
          error => {
            this.error(error.response.statusText);
          }
        );
    }
  }

  deleteForum(id) {
    axios
      .post(`${URL.api}communication/forum/delete/${id}`, null, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ deleteModal: false });

          this.updateForum();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  updateForum() {
    const { id } = this.props.match.params;
    const forumId = window.location.pathname.substr(
      window.location.pathname.lastIndexOf("/") + 1
    );

    axios
      .post(`${URL.api}communication/forum/singleView/${forumId}`, null, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success === false) {
            this.props.navigate(
              `${(this.props.isRoom ? "/room/" : "/classroom/") + id}/forums`
            );
          } else {
            this.setState({
              forum:
                resp.data.data.room_id === parseInt(id) ? resp.data.data : null,
              loading: false
            });
          }
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    const { forum } = this.state;

    return (
      <>
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <React.Fragment>
            <CModal
              show={this.state.deleteModal}
              onClose={() => this.setState({ deleteModal: false })}
              closeOnBackdrop={false}
            >
              <CModalHeader closeButton className="bg-danger">
                <CModalTitle>Apagar discussão</CModalTitle>
              </CModalHeader>
              <CModalBody>Deseja apagar a discussão selecionada?</CModalBody>
              <CModalFooter>
                <CButton
                  color="danger"
                  onClick={() => this.deleteForum(this.state.deleteId)}
                >
                  Apagar
                </CButton>{" "}
                <CButton
                  color="secondary"
                  onClick={() => this.setState({ deleteModal: false })}
                >
                  Cancelar
                </CButton>
              </CModalFooter>
            </CModal>
            {forum ? (
              <React.Fragment>
                <CCard key={forum.id}>
                  <CCardBody>
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="c-avatar mr-2">
                          <img
                            className="c-avatar-img"
                            src={
                              forum.user_photo
                                ? URL.img + forum.user_photo
                                : `${URL.img}uploads/users/profileEmpty.jpg`
                            }
                            alt=""
                          />
                        </div>
                        <div className="d-block w-100">
                          <div className="d-flex">
                            <span className="d-flex" style={{ flex: 1 }}>
                              {forum.user_name}
                            </span>
                            {forum.user_id === this.props.user.user.id && (
                              <CDropdown className="card-notice-menu">
                                <CDropdownToggle
                                  color="white"
                                  className="card-header-action remove-caret"
                                >
                                  <i className="fa fa-ellipsis-v"></i>
                                </CDropdownToggle>
                                <CDropdownMenu placement="top">
                                  <CDropdownItem
                                    onClick={() =>
                                      this.setState({
                                        deleteModal: true,
                                        deleteId: forum.id
                                      })
                                    }
                                  >
                                    Apagar
                                  </CDropdownItem>
                                </CDropdownMenu>
                              </CDropdown>
                            )}
                          </div>
                          <div className="text-muted">
                            {this.friendlyDate(forum.created_at)}
                          </div>
                        </div>
                      </div>
                      <h5 className="mt-3 mb-2">{forum.title}</h5>
                    </div>
                    <div className="text-muted">{forum.description}</div>
                  </CCardBody>
                  <CCardFooter className="d-flex justify-content-end">
                    <CBadge color="light" className="ml-2 p-2 cursor btn-light">
                      <i className="fa fa-comments mr-2"></i>
                      {forum.comments}
                    </CBadge>
                    <CBadge
                      color={
                        forum.user_like === true ? "btn-primary" : "btn-light"
                      }
                      className={`ml-2 p-2 cursor ${
                        forum.user_like === true ? "btn-primary" : "btn-light"
                      }`}
                      onClick={() => this.like(forum, true)}
                    >
                      <i className="fa fa-thumbs-up mr-2"></i>
                      {forum.likes}
                    </CBadge>
                    <CBadge
                      color={
                        forum.user_like === false ? "btn-danger" : "btn-light"
                      }
                      className={`ml-2 p-2 cursor ${
                        forum.user_like === false ? "btn-danger" : "btn-light"
                      }`}
                      onClick={() => this.like(forum, false)}
                    >
                      <i className="fa fa-thumbs-down mr-2"></i>
                      {forum.nlikes}
                    </CBadge>
                  </CCardFooter>
                </CCard>
                {forum.forums
                  .filter(
                    forum =>
                      forum.description
                        .toLowerCase()
                        .includes(this.props.search.toLowerCase()) ||
                      forum.user_name
                        .toLowerCase()
                        .includes(this.props.search.toLowerCase())
                  )
                  .map(comment => (
                    <React.Fragment key={comment.id}>
                      <div className="timeline"></div>
                      <CCard>
                        <CCardBody>
                          <div>
                            <div className="d-flex align-items-center">
                              <div className="c-avatar mr-2">
                                <img
                                  className="c-avatar-img"
                                  src={
                                    comment.user_photo
                                      ? URL.img + comment.user_photo
                                      : `${URL.img}uploads/users/profileEmpty.jpg`
                                  }
                                  alt=""
                                />
                              </div>
                              <div className="d-block w-100">
                                <div className="d-flex">
                                  <span className="d-flex" style={{ flex: 1 }}>
                                    {comment.user_name}
                                  </span>
                                  {comment.user_id ===
                                    this.props.user.user.id && (
                                    <CDropdown className="card-notice-menu">
                                      <CDropdownToggle
                                        color="white"
                                        className="card-header-action remove-caret"
                                      >
                                        <i className="fa fa-ellipsis-v"></i>
                                      </CDropdownToggle>
                                      <CDropdownMenu placement="top">
                                        <CDropdownItem
                                          onClick={() =>
                                            this.setState({
                                              deleteModal: true,
                                              deleteId: comment.id
                                            })
                                          }
                                        >
                                          Apagar
                                        </CDropdownItem>
                                      </CDropdownMenu>
                                    </CDropdown>
                                  )}
                                </div>
                                <div className="text-muted">
                                  {this.friendlyDate(comment.created_at)}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="text-muted mt-3">
                            {comment.description}
                          </div>
                          <div className="d-flex justify-content-end">
                            <CBadge
                              color="light"
                              className="ml-2 p-2 cursor btn-light"
                              onClick={() =>
                                this.setState({
                                  answerId: comment.id,
                                  answer: ""
                                })
                              }
                            >
                              <i className="fa fa-comments mr-2"></i>
                              {comment.comments}
                            </CBadge>
                            <CBadge
                              color={
                                comment.user_like === true
                                  ? "btn-primary"
                                  : "btn-light"
                              }
                              className={`ml-2 p-2 cursor ${
                                comment.user_like === true
                                  ? "btn-primary"
                                  : "btn-light"
                              }`}
                              onClick={() => this.like(comment, true)}
                            >
                              <i className="fa fa-thumbs-up mr-2"></i>
                              {comment.likes}
                            </CBadge>
                            <CBadge
                              color={
                                comment.user_like === false
                                  ? "btn-danger"
                                  : "btn-light"
                              }
                              className={`ml-2 p-2 cursor ${
                                comment.user_like === false
                                  ? "btn-danger"
                                  : "btn-light"
                              }`}
                              onClick={() => this.like(comment, false)}
                            >
                              <i className="fa fa-thumbs-down mr-2"></i>
                              {comment.nlikes}
                            </CBadge>
                          </div>
                        </CCardBody>
                      </CCard>
                      {comment.forums
                        .filter(
                          forum =>
                            forum.description
                              .toLowerCase()
                              .includes(this.props.search.toLowerCase()) ||
                            forum.user_name
                              .toLowerCase()
                              .includes(this.props.search.toLowerCase())
                        )
                        .map(answer => (
                          <React.Fragment>
                            <div className="timeline"></div>
                            <CCard className="ml-5">
                              <CCardBody>
                                <div>
                                  <div className="d-flex align-items-center">
                                    <div className="c-avatar mr-2">
                                      <img
                                        className="c-avatar-img"
                                        src={
                                          answer.user_photo
                                            ? URL.img + answer.user_photo
                                            : `${URL.img}uploads/users/profileEmpty.jpg`
                                        }
                                        alt=""
                                      />
                                    </div>
                                    <div className="d-block w-100">
                                      <div className="d-flex">
                                        <span
                                          className="d-flex"
                                          style={{ flex: 1 }}
                                        >
                                          {answer.user_name}
                                        </span>
                                        {answer.user_id ===
                                          this.props.user.user.id && (
                                          <CDropdown className="card-notice-menu">
                                            <CDropdownToggle
                                              color="white"
                                              className="card-header-action remove-caret"
                                            >
                                              <i className="fa fa-ellipsis-v"></i>
                                            </CDropdownToggle>
                                            <CDropdownMenu placement="top">
                                              <CDropdownItem
                                                onClick={() =>
                                                  this.setState({
                                                    deleteModal: true,
                                                    deleteId: answer.id
                                                  })
                                                }
                                              >
                                                Apagar
                                              </CDropdownItem>
                                            </CDropdownMenu>
                                          </CDropdown>
                                        )}
                                      </div>
                                      <div className="text-muted">
                                        {this.friendlyDate(answer.created_at)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="text-muted mt-3">
                                  {answer.description}
                                </div>
                                <div className="d-flex justify-content-end">
                                  <CBadge
                                    color={
                                      answer.user_like === true
                                        ? "btn-primary"
                                        : "btn-light"
                                    }
                                    className={`ml-2 p-2 cursor ${
                                      answer.user_like === true
                                        ? "btn-primary"
                                        : "btn-light"
                                    }`}
                                    onClick={() => this.like(answer, true)}
                                  >
                                    <i className="fa fa-thumbs-up mr-2"></i>
                                    {answer.likes}
                                  </CBadge>
                                  <CBadge
                                    color={
                                      answer.user_like === false
                                        ? "btn-danger"
                                        : "btn-light"
                                    }
                                    className={`ml-2 p-2 cursor ${
                                      answer.user_like === false
                                        ? "btn-danger"
                                        : "btn-light"
                                    }`}
                                    onClick={() => this.like(answer, false)}
                                  >
                                    <i className="fa fa-thumbs-down mr-2"></i>
                                    {answer.nlikes}
                                  </CBadge>
                                </div>
                              </CCardBody>
                            </CCard>
                          </React.Fragment>
                        ))}
                      {this.state.answerId === comment.id && (
                        <>
                          <div className="timeline"></div>
                          <CCard className="ml-5" id="answer">
                            <CCardBody>
                              <CTextarea
                                value={this.state.answer}
                                onChange={e =>
                                  this.setState({ answer: e.target.value })
                                }
                                placeholder="Digite sua resposta"
                                className="p-3"
                                rows={4}
                                style={{ resize: "none" }}
                              />
                            </CCardBody>
                            <CCardFooter className="d-flex justify-content-end">
                              <CButton
                                color="primary"
                                onClick={() => this.answer()}
                              >
                                <i className="fa fa-send mr-2"></i> Enviar
                              </CButton>
                            </CCardFooter>
                          </CCard>
                        </>
                      )}
                    </React.Fragment>
                  ))}
                <div className="timeline"></div>
                <CCard id="comment">
                  <CCardBody>
                    <CTextarea
                      value={this.state.comment}
                      onChange={e => this.setState({ comment: e.target.value })}
                      placeholder="Digite seu comentário"
                      className="p-3"
                      rows={4}
                      style={{ resize: "none" }}
                    />
                  </CCardBody>
                  <CCardFooter className="d-flex justify-content-end">
                    <CButton color="primary" onClick={() => this.comment()}>
                      <i className="fa fa-send mr-2"></i> Enviar
                    </CButton>
                  </CCardFooter>
                </CCard>
              </React.Fragment>
            ) : (
              <div className="d-flex align-items-center justify-content-center m-3">
                Discussão não encontrada
              </div>
            )}
          </React.Fragment>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentForum);
